<template>
    <div class="vertical-flow select-modal">
        <div class="registry-wrapper">
            <div class="modal-icons" v-show="hasOcorrenciaSelecionada">
                <svg class="svg-icons" @click="openModal('geral')">
                    <use :xlink:href="require('@/assets/img/icons/card-reader.svg') + '#layer'" />
                </svg>
                <svg
                    class="svg-icons"
                    @click="openModal('produtos-ocorrencia')"
                    v-show="ocorrenciaHasProdutos"
                >
                    <use :xlink:href="require('@/assets/img/icons/cash-register.svg') + '#layer'" />
                </svg>
                <svg
                    class="svg-icons"
                    @click="openModal('anexos-ocorrencia')"
                    v-show="ocorrenciaHasAnexos"
                >
                    <use :xlink:href="require('@/assets/img/icons/no-image.svg') + '#layer'" />
                </svg>
            </div>
            <div class="add-fotos" v-if="permissao.create && situacao != 1">
                <div class="columns">
                    <div class="file-picker-input">
                        <file-picker
                            v-if="permissao.create"
                            ref="filePicker"
                            class="upload-picker"
                            v-model="file"
                            :accepted="acceptedTypes"
                            :allowedtypes="allowedTypes"
                            @alert="showMessage"
                            :disabled="disabled"
                            returnRawFile
                        />
                    </div>
                    <div class="listing-header mb-4">
                        <div class="title-breadcrumb"></div>
                        <div class="header-buttons">
                            <button
                                class="save-btn"
                                type="button"
                                :disabled="!file"
                                @click="addAnexoCall"
                            >
                                {{ $t('salvar') }}
                                <button-loader :isSaving="disabled" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TABELA -->
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <empty-table-message v-if="isEmpty" />

            <b-table v-else class="data-table" :data="fotos" @sort="sortTable" backend-sorting>
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.field"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{
                        'excluir-field': f.key == 'excluir',
                    }"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div v-if="f.key == 'excluir'">
                        <span v-if="permissao.delete">
                            <b-button
                                class="action-button"
                                type="is-danger"
                                icon-right="delete"
                                @click="confirmExclusion(props.row)"
                                v-tippy
                                :title="$t('excluir')"
                            />
                        </span>
                    </div>
                    <div v-else-if="f.field == 'datahorainc'">
                        {{ props.row[f.field] | moment('L LT') }}
                    </div>
                    <div v-else-if="f.field == 'nome'">
                        {{ props.row[f.field] }}
                    </div>
                    <div
                        v-else-if="
                            f.field == 'caminho' &&
                            props.row[f.field] &&
                            ['jpg', 'jpeg', 'png'].includes(
                                props.row['nome']
                                    .split('.')
                                    [props.row['nome'].split('.').length - 1].toLowerCase()
                            )
                        "
                    >
                        <a :href="props.row[f.field]" target="_blank" v-if="!isLoading">
                            <img
                                :src="props.row[f.field]"
                                class="img-anexo"
                                :title="props.row['nome']"
                                :alt="props.row['nome']"
                            />
                        </a>
                    </div>
                    <div v-else>
                        <a :href="props.row[f.field]" target="_blank" v-if="!isLoading">
                            <img
                                :src="require('@/assets/img/file.png')"
                                class="img-anexo"
                                :title="props.row['nome']"
                                :alt="props.row['nome']"
                            />
                        </a>
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// #71157
import AgroVisitaItemFotoService from '@/services/agro/agrovisita/AgroVisitaItemFotoService';
import FilePicker from '@/components/shared/form/FilePicker';
import AgroVisitaValidation from '@/services/validations/agro/AgroVisitaValidation';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        FilePicker,
        ContainerLoader,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        situacao: {
            type: Number,
            default: 0,
        },
        hasOcorrenciaSelecionada: {
            type: Boolean,
            default: false,
        },
        ocorrenciaHasProdutos: {
            type: Boolean,
            default: false,
        },
        ocorrenciaHasAnexos: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AgroVisitaItemFotoService(this.$http, this.$router),
            validation: new AgroVisitaValidation(this.$root.msgs),
            fotos: [],
            situacaoSelected: { label: 'ativo', id: 1 },
            situacaoSelect: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            fields: [
                { key: 'arquivo', field: 'caminho', sortable: false },
                { key: 'nome', field: 'nome', sortable: false },
                { key: 'datahorainc', field: 'datahorainc', sortable: false },
                { key: 'excluir', label: 'excluir', width: 20, sortable: false },
            ],
            file: '',
            delete: null,
            allowedTypes: ['image/jpeg', 'image/png'],
            acceptedTypes: '.jpeg,.jpg,.png',
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'arquivo',
            order: 'asc',
            fromDelete: false,
            disabled: false,
            isEmpty: false,
            isLoading: false,
            loadingFoto: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('agro', 'agro-visita', 'agro-visita');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-visita-item' },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-foto-' + numberId;
        },
        carregarDados(currentPage = 1) {
            this.fotos = [];
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            let params = {};

            this.service
                .findAllByUuid(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.$route.params.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.fotos = Object.assign(value);
                    this.isEmpty = this.fotos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    console.error(e);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idagro_visitaitemfoto: m.idagro_visitaitemfoto,
                    idagro_visitaitemfotoerp: m.idagro_visitaitemfotoerp,
                    nome: m.nome,
                    caminho: this.isHttpUrlValid(m.caminho)
                        ? m.caminho
                        : m.documentopda
                        ? m.documentopda.url_documento
                        : m.caminho,
                    tipo: m.tipo,
                    uuid: m.uuid,
                    datahorainc: m.datahorainc,
                };
            });
        },
        addAnexoCall() {
            this.addAnexo({
                nome: this.$refs.filePicker.file.name,
            });
            this.file = '';
            this.$refs.filePicker.clearFile();
        },
        addAnexo(anexo) {
            anexo.uuidagro_visitaitem = this.$route.params.id;
            this.isLoading = true;
            this.loadingFoto = true;
            anexo = this.mapToupload(anexo);
            this.service
                .save(this.$refs.filePicker.file, anexo)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Erro ${r.status} ao salvar anexo.`);
                        console.error(`Mensagem: ${r.message}`);
                        this.$root.showMessage('error', 'msg-erro-ven-cliente-anexo-upload');
                    } else {
                        this.$root.showMessage('success', 'msg-anexo-salvo-sucesso');
                        this.carregarDados();
                    }
                })
                .finally((f) => {
                    this.loadingFoto = false;
                    this.isLoading = false;
                });
        },
        confirmExclusion(anexo) {
            this.delete = anexo;

            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n: this.delete.nome }),
                onConfirm: (_) => this.deleteRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deleteRegistro() {
            this.isLoading = true;
            this.service
                .delete(this.delete.uuid)
                .then((value) => {
                    if (value.message == null) {
                        // novo modelo de mensagem dinâmica
                        let msg = this.$t('msg-delete-sucesso', { n: this.$t('foto') });
                        this.$root.showMessage('success', msg, true, false);

                        this.carregarDados(this.pagination.currentPage);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openModal(buttonClicked) {
            let info = {
                buttonClicked: buttonClicked,
            };
            this.$emit('open-modal-info-ocorrencia', info);
        },
        showMessage(data) {
            this.$root.showMessage(data.type, data.message);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
    },
};
</script>
<style lang="scss" scoped>
.file-picker-input {
    flex-grow: 1;
}

.upload-picker {
    height: 100px;
    margin: 12px;
    margin-bottom: 24px;
}
.img-anexo {
    height: 48px;
}
.data-table .ml-1 {
    margin-left: 0 !important;
}

.svg-loader {
    margin-left: 0 !important;
}

.save-btn {
    margin: 12px;
    margin-top: 24px;
}

.modal-icons {
    .svg-icons {
        margin-right: 5px;
        width: 35px;
        height: 35px;
        fill: $semi-title-color;
        cursor: pointer;
    }
}

@media only screen and (max-width: 760px) {
    .add-anexo {
        .column.is-flex {
            flex-wrap: wrap;
        }
        .save-btn {
            margin-top: 0;
        }
        .upload-picker {
            margin-bottom: 0;
        }
    }
    .svg-loader {
        margin-right: 0.5rem;
    }
}
</style>
